import { a as languages } from "../../core-8vQkh0Rd.js";
import { r as insertBefore } from "../../language-D-vtM55V.js";
import { n as re } from "../../shared-BPLAFNn7.js";
import { r as space, t as addJsxTag } from "../../jsx-shared-DIcqKxFi.js";
import "./typescript.js";
import "./jsx.js";
//#region src/prism/languages/tsx.js
var tsx = addJsxTag(languages.ts, "tsx");
var tag = tsx["tag"];
var bracket = "(?:^|(";
try {
	bracket += "?<=";
} catch {
	tag.lookbehind = true;
}
tag.pattern = RegExp(bracket + `[^\\w$])|(?=</))${tag.pattern.source.replace(space, space + `|(?:${space})*<(?:[^<>=]|=[^<]|=?<(?:[^<>]|<[^<>]*>)*>)*>`)}`, "g");
insertBefore(tag.inside, "attr-value", { "generic": {
	pattern: re("(^<0>*)<(?:[^<>=]|=[^<]|=?<(?:[^<>]|<[^<>]*>)*>)*>", [space]),
	lookbehind: true,
	alias: "class-name",
	inside: tsx["class-name"].inside
} });
//#endregion

//# sourceMappingURL=tsx.js.map